import React, { useCallback, useMemo } from 'react';
import { PropTypes } from 'prop-types';
import { Trans, useTranslation } from 'react-i18next';
import { useFeasibility } from 'hooks/useFeasibility';
import { REASONS } from 'utils/feasibility/constants';
import { useSelector } from 'react-redux';
import { selectors as orderSelectors } from 'state/order';
import { getRoute } from './QuoteMessageNonFeasible.utils';
import config from 'config';
import { Link } from '@ontruck/orc';

const QuoteMessageNonFeasible = ({ className }) => {
  const { t } = useTranslation('Quote');
  const { orderType, reason } = useFeasibility();
  const shipments = useSelector(orderSelectors.getShipmentsForQuote);
  const lhExpressLink = useMemo(() => config.LH_EXPRESS_LINK, []);

  const renderMessage = useCallback(() => {
    if (reason === REASONS.LH_EXPRESS) {
      return (
        <>
          <p>{t('non_feasible.lh_express')}</p>
          <p>
            <Link
              href={lhExpressLink}
              skin="light"
              text={t('non_feasible.lh_express_secondary_link')}
              target="_blank"
              className="quote-message-non-feasible__secondary-link"
            />
          </p>
        </>
      );
    }
    if (reason === REASONS.NON_CORE_SALES_AREA) {
      const route = getRoute(shipments, orderType);
      return (
        <>
          <p>
            <Trans
              t={t}
              i18nKey="non_feasible.non_core_sales_area"
              values={{ route }}
            />
          </p>
          <p>
            <Trans
              t={t}
              i18nKey="non_feasible.generic_message"
              components={[<b />]}
            />
          </p>
        </>
      );
    }
    if (reason === REASONS.TRAILER_WITH_LIFTGATE) {
      return (
        <>
          <p>{t('non_feasible.trailer_with_liftgate')}</p>
          <p>
            <Trans
              t={t}
              i18nKey="non_feasible.generic_message"
              components={[<b />]}
            />
          </p>
        </>
      );
    }
    // generic (reason FOR POSTAL CODES and otther possible reasons)
    return (
      <>
        <Trans
          t={t}
          i18nKey="non_feasible.generic_message"
          components={[<b />]}
        />
      </>
    );
  }, [reason, orderType, shipments, t, lhExpressLink]);

  return (
    <div className={className} data-testid="quote-message-non-feasible">
      {renderMessage()}
    </div>
  );
};

QuoteMessageNonFeasible.propTypes = {
  className: PropTypes.string,
};

export default QuoteMessageNonFeasible;
